import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'; // Импортируем ToastContainer

import 'react-toastify/dist/ReactToastify.css'; // Импортируем стили

import App from './App';

import './styles.css'; // Глобальные стили (если есть)
import './reset.css'; // Путь к файлу reset.css
import './fonts.css'; // Путь к файлу reset.css

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
    <ToastContainer
      position="top-right" // Позиция toast-сообщений
      autoClose={5000} // Автоматическое закрытие через 5 секунд
      hideProgressBar={false} // Показывать прогресс-бар
      newestOnTop={false} // Новые сообщения появляются снизу
      closeOnClick // Закрывать по клику
      rtl={false} // Направление текста (слева направо)
      pauseOnFocusLoss // Пауза при потере фокуса окна
      draggable // Возможность перетаскивать toast
      pauseOnHover // Пауза при наведении
    />
  </BrowserRouter>
);
